import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';

@Component({
  selector: 'app-payment-status',
  templateUrl: './payment-status.component.html',
  styleUrls: ['./payment-status.component.scss'],
})
export class PaymentStatusComponent  {
url;
success:boolean = false;
failure:boolean = false;
pending:boolean = false;
PASS:boolean = false;
FAIL:boolean = false;
  constructor(private router: Router,public handler: HandlerService) { }

 ionViewWillEnter(){
  console.log(this.handler.payObj)
  this.url = window.location.href;
  if(this.url.includes('success')){
    this.success = true;
  }else if(this.url.includes('failure')){
    this.failure = true;
  }else if(this.url.includes('pending')){
    this.pending = true;
  }else if(this.url.includes('PASS')){
    this.PASS = true;
  }else if(this.url.includes('FAIL')){
    this.FAIL = true;
  }
 }

 @HostListener('window:popstate', ['$event'])
 onPopState(event) {   
   this.router.navigate(['/bookservice1'])  
 }


 goBack(){
  this.router.navigate(['/bookservice1'])
 }

}
